import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@lionstep/ui';

// Components
import { CandidatePlaceholder } from '../../../../../../components/refactoring/placeholders';

// Hooks
import useMediaQuery from '../../../../../../hooks/useMediaQuery';

// Styles
import styles from './validatedCandidatesPlaceholder.module.scss';

const ValidatedCandidatesPlaceholder = ({ isFetching }) => {
  const { t } = useTranslation();
  const { activeBreakpoints } = useMediaQuery();

  return (
    <CandidatePlaceholder
      className={styles.placeholder}
      position={activeBreakpoints.includes('sm') ? 'right' : 'bottom'}
    >
      {isFetching && <Spinner position="absolute" size={50} />}
      <span className={styles.placeholderText}>
        {t('dashboard_page.new_validated_candidates.no_new_validated')}
      </span>
    </CandidatePlaceholder>
  );
};

ValidatedCandidatesPlaceholder.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};

export default ValidatedCandidatesPlaceholder;
